// Externals
import React from "react";
import { navigate, useBasePath } from "raviger";

import "./PetProfileCard.scss";

const PetProfileCard = ({ props, storeId }) => {
	const basepath = useBasePath();
	let imagePath = typeof(props?.image[0]?.image_path) === 'undefined' ?
		'/wp-content/uploads/2024/12/noPhotoFound.png' :
		'/wp-content/uploads/animals/' + props?.image[0]?.image_path;

	return (
		<div
			className="pet-profile-card"
			onClick={() =>
				navigate(`${basepath}/pet-profile/${props.id}`, {
					sid: storeId,
				})
			}
		>
			<div className="pet-profile-image">
				<img
					src={imagePath}
					width="100%"
					alt="pet-profile-img"
				/>
			</div>
			<div className="pet-details">
				<div className="pet-name">{props.name}</div>
				<div className="pet-breed">{props.breed_primary}</div>
				<div className="pet-age">{props.age_for_adoption}</div>
			</div>
		</div>
	);
};

// Exports
export default PetProfileCard;
